import React, { useState } from "react";
import { getPluralForm, ignoreResourceLibraryWord } from "../../../utils/plural";

const MenuButton = ({ children, isPrimary, isActive, isAssetLink, title, id, selectedButtonId, setSelectedButtonId, ...otherProps }) => {

    const hideSpan = id === selectedButtonId;

    return (
        <button
            {...otherProps}
            title={title}
            className={`
            tw-font-sans tw-font-light tw-text-[18px]
			tw-bg-transparent tw-w-full tw-text-left tw-text-text tw-p-0 tw-mb-4
			hover:!tw-bg-transparent focus:!tw-bg-transparent
			tw-flex tw-justify-between tw-items-center
			tw-border-solid tw-border-0 tw-border-l-2 tw-border-transparent
            ${isActive ? "tw-border-l-secondary tw-pl-4" : "tw-pl-4"}
            ${isAssetLink ? "" : ""}
            `}
            onClick={() => {
                setSelectedButtonId(hideSpan ? null : id); // Toggle the selected button ID
                if (otherProps.onClick) {
                    otherProps.onClick(); // Call any existing onClick handler
                }
            }}
        >
            {children}
            {!isActive ? (
                <span className="icon-right-arrow tw-text-[8px]"></span>
            ) : (
                <span></span>
            )}
        </button>
    );
};

function getDisplayName(item) {
    if (!item) return '';
    if (item.displayName) return item.displayName;
    if (ignoreResourceLibraryWord(item.name)) return item.name;
    if (item.parent?.id === 1) return getPluralForm(item.name);
    return item.name;
}

export default function MenuMulti({
    activeMenuId = -1,
    menuItems,
    label = "All Topics",
    globalTopic = "",
    onItemClick = (item = {}) => { },
    goBack = null,
}) {
    const [selectedButtonId, setSelectedButtonId] = useState(null); // State for the currently selected button ID

    return (
        <section className="tw-w-full tw-max-w-full tw-p-12 tw-pt-0">
            <h2
                {...(goBack ? { role: "button" } : {})}
                className="tw-text-[14px] tw-font-bold"
                onClick={() => {
                    if (goBack) {
                        goBack();
                        setSelectedButtonId(null); // Reset selected button ID when going back
                    }
                }}
            >
                {goBack ? (
                    <span className="icon-left-arrow tw-text-[8px] tw-inline-block tw-mr-2 tw--ml-6"></span>
                ) : null}
                {label}
            </h2>
            {globalTopic ? (
                <div className="tw-font-sans tw-font-bold tw-mb-2 tw-text-[18px]">
                    {globalTopic.replace("All ", "")}
                </div>
            ) : null}
            {menuItems.map((item) => (
                <MenuButton
                    key={item.id}
                    id={item.id}
                    isPrimary={activeMenuId}
                    isActive={item.id === activeMenuId && !item.children.length}
                    isAssetLink={item.children?.length}
                    selectedButtonId={selectedButtonId}
                    setSelectedButtonId={setSelectedButtonId}
                    onClick={() => {
                        onItemClick(item);
                        }}
                    title={item.name}
                >
                    {item.name}
                </MenuButton>
            ))}
        </section>
    );
}